import EcocolordopplerArtiSuperioriEdit from "./components/EcocolordopplerArtiSuperioriEdit.vue";
import EcocolordopplerArtiSuperioriView from "./components/EcocolordopplerArtiSuperioriView.vue";
import EcocolordopplerArtiSuperioriList from "./components/EcocolordopplerArtiSuperioriList.vue";

export default {
    EcocolordopplerArtiSuperioriEdit,
    EcocolordopplerArtiSuperioriView,
    EcocolordopplerArtiSuperioriList,
};
